import Axios from 'axios';
import {useHHttp} from "@/hooks/useHHttp.js"
import {log, kDebug} from "@/components/utils/HComFunctions.js";
import {hsp} from "@/components/utils/HSp.js";
import {hdi} from "@/components/utils/HDeviceInfo.js";
import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

class MgSelectLinesLogic {
    // 单例模式，保证只创建一次实例
    static instance;

    static getInstance(callback) {
        if (!this.instance) {
            this.instance = new MgSelectLinesLogic(callback);
        }
        return this.instance;
    }

    constructor(callback) {
        this.preLineList = [
            "https://www.game250522linecfg.xyz",
            "https://www.ylhg250627linecfg.xyz",
            "https://www.tt250627linecfg.xyz",
            "https://line.yongli250627linecfg.xyz"
        ];
        this.helpLines = [
            "https://gitee.com/lspxgit/yongli/raw/main/helpline.txt",
            "https://raw.githubusercontent.com/kaerkaerkaerzzz/yongli/main/helpline.txt"
        ];

        this.fastLineUrl = "";
        this.findFastLineTimer = null;
        this.dio = Axios.create({
            baseURL: '',
        });

        this.dio.defaults.headers.common['Access-Control-Max-Age'] = '43200';
        this.dio.defaults.headers.common['content-type'] = 'text/plain';

        this.tryCount = 0;

        // 获取本地线路数据
        let localLines = hsp.getStringList("SELECT_LINE_LIST");
        if (localLines) {
            this.processUpdateLine(localLines);
        } else {
            hsp.setStringList("SELECT_LINE_LIST", this.preLineList);
        }

        this.successCallback = callback;

        this.formHeaderTodo();
    }

    // 定时获取最快线路
    formHeaderTodo() {
        this.findFastLine();
        if (this.findFastLineTimer) {
            clearInterval(this.findFastLineTimer);
        }
        this.findFastLineTimer = setInterval(() => {
            if (this.fastLineUrl === "") {
                this.findFastLine();
                this.tryCount++;
                if (this.tryCount > 2) {
                    clearInterval(this.findFastLineTimer);
                    this.findFastLineTimer = null;
                    this.checkHelp();
                    this.tryCount = 0;
                }
            }
        }, 3000);
    }

    // 检查帮助线路
    checkHelp() {
        for (let i = 0; i < this.helpLines.length; i++) {
            this.testSpeed({"ApiGw": this.helpLines[i], "AliasApiGw": ""}, true, true).then(async (obj) => {
                try {
                    const response = await this.dio.get(obj.ApiGw);
                    if (response.status === 200) {
                        const allLines = response.data;
                        this.processUpdateLine(allLines);
                        this.formHeaderTodo();
                    }
                } catch (e) {
                    log(e.stack);
                }
            });
        }

        setTimeout(() => {
            if (this.fastLineUrl === "") {
                this.formHeaderTodo();
            }
        }, 5000);
    }

    // 获取最快线路
    findFastLine() {
        for (let i = 0; i < this.preLineList.length; i++) {
            this.testSpeed({"ApiGw": this.preLineList[i], "AliasApiGw": ""},false,true).then(async (obj) => {
                if (obj.ApiGw && obj.ApiGw["ApiGw"] !== "" && this.fastLineUrl === "") {
                    this.fastLineUrl = obj.ApiGw;
                    clearInterval(this.findFastLineTimer);
                    this.findFastLineTimer = null;
                    this.updateNewLineList();
                    this.requestServerList();
                }
            });
        }
    }

    // 请求服务器列表
    requestServerList() {
        this.dio.get(`${this.fastLineUrl}/apigw/cfg?t=${Date.now()}${Math.random().toString(36).slice(2, 5)}`)
            .then(response => {
                if (response.status === 200) {
                    this.findFastServerInto(response.data);
                }
            })
            .catch((e) => {
                log(e.stack);
            });
    }

    // 更新线路列表
    updateNewLineList() {
        this.dio.get(`${this.fastLineUrl}/line/cfg?t=${Date.now()}${Math.random().toString(36).slice(2, 5)}`)
            .then(response => {
                if (response.status === 200) {
                    const newLineList = response.data;
                    this.processUpdateLine(newLineList);
                }
            })
            .catch((e) => {
                log(e.stack);
            });
    }

    // 更新线路信息
    processUpdateLine(newLineList) {
        newLineList.forEach(line => {
            if (!this.preLineList.includes(line)) {
                this.preLineList.push(line);
            }
        });
        hsp.setStringList("SELECT_LINE_LIST", this.preLineList);
    }

    // 测试线路速度
    async testSpeed(obj, onlySpeed =false, isPingLine = false) {
        try {
            const response = await this.dio.get(`${obj.ApiGw}/api-speed?t=${Date.now()}${Math.random().toString(36).slice(2, 5)}`);
            if (onlySpeed) {
                return obj;
            } else {
                if (response.status === 200 && response.data.Code === 0) {
                    return obj;
                } else {
                    return {"ApiGw": "", "AliasApiGw": ""};
                }
            }
        } catch (e) {
            if (onlySpeed) {
                return obj;
            } else {
                return {
                    "ApiGw": "",
                    "AliasApiGw": "",
                };
            }
        }
    }

    // 根据速度找出最快的服务器
    findFastServerInto(serverList) {
        serverList.forEach(async (server) => {
            const obj = await this.testSpeed(server);
            if (obj.ApiGw && obj.ApiGw["ApiGw"] !== "" && useHHttp().getServerUrlsConfig().ApiGw === "") {
                useHHttp().setServerUrlsConfig(obj);
                //测试服
                let devStr = hsp.getMap("DEV_DEBUG");
                if (devStr != null) {
                    hdi.channelFlag = HNewGameUIConfig.newGameUIType === 0
                        ? "devv"
                        : hdi.channelFlag;
                    useHHttp().setServerUrlsConfig(devStr);
                }
                // 开发环境下，URL query 中的 host 参数优先级最高
                if (kDebug) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const hostParam = urlParams.get('host');
                    if (hostParam) {
                        useHHttp().setServerUrlsConfig({
                            "ApiGw": hostParam,
                            "AliasApiGw": "URL参数指定"
                        });
                    }
                }
                //~
                if (this.findFastLineTimer) {
                    clearInterval(this.findFastLineTimer);
                    this.findFastLineTimer = null;
                }

                let thirdCode = localStorage.getItem("thirdCode");
                if (thirdCode == null) {
                    thirdCode = "";
                }

                useHHttp().request("/app/device/upload", () => {
                    },
                    {
                        params: {
                            "Did": hdi.deviceId,
                            "Code": HNewGameUIConfig.newGameUIType === 0
                                ? hdi.inviteCode
                                : "",
                            "PlatTypeNum": hdi.platTypeNo,
                            "ThirdCode":HNewGameUIConfig.newGameUIType === 0
                                ? ""
                                : thirdCode,
                        },
                        isShowLoading: false
                    }).then(() => {
                });
                if (this.successCallback != null) {
                    this.successCallback();
                }
            }
        });

        setTimeout(() => {
            if (useHHttp().getServerUrlsConfig().ApiGw === "") {
                this.formHeaderTodo();
            }
        }, 5000);
    }
}

export default MgSelectLinesLogic;
